import { render, staticRenderFns } from "./The404Page.vue?vue&type=template&id=c901f172&scoped=true"
import script from "./The404Page.vue?vue&type=script&lang=js"
export * from "./The404Page.vue?vue&type=script&lang=js"
import style0 from "./The404Page.vue?vue&type=style&index=0&id=c901f172&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c901f172",
  null
  
)

export default component.exports